export default () => {
  return {
    initial: {
      query: '',
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'referral::referral_links.filters.input.label',
        placeholder: 'referral::referral_links.filters.input.label',
        order: 1,
        type: 'input',
      },
    },
  }
}
